import { render, staticRenderFns } from "./my-saved-reports.vue?vue&type=template&id=04b08139&scoped=true"
import script from "./my-saved-reports.vue?vue&type=script&lang=js"
export * from "./my-saved-reports.vue?vue&type=script&lang=js"
import style0 from "./my-saved-reports.vue?vue&type=style&index=0&id=04b08139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b08139",
  null
  
)

export default component.exports